import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { urls } from "@/urls";

export const loginRoutes = {
  path: urls.login,
  async lazy() {
    const { Login } = await import("./Login");
    return { Component: Login };
  },
};

export const registrationRoutes = {
  path: urls.registration,
  async lazy() {
    const { Registration: SignUp } = await import("./Registration");
    return { Component: SignUp };
  },
};

// 平面（V/M）方案已下架，舊連結一律轉到空間方案頁（保留 ?subscription=expired 等參數）
export const planRoutes = {
  path: urls.plan,
  loader: ({ request }: LoaderFunctionArgs) =>
    redirect(urls.interior_plan + new URL(request.url).search),
};

export const interiorPlanRoutes = {
  path: urls.interior_plan,
  async lazy() {
    const { InteriorPlan } = await import("./InteriorPlan");
    return { Component: InteriorPlan };
  },
};

export const forgetPasswordRoutes = {
  path: urls.forget_password,
  async lazy() {
    const { ForgetPassword } = await import("./ForgetPassword");
    return { Component: ForgetPassword };
  },
};

export const adminPinSetupRoutes = {
  path: urls.admin_pin_setup,
  async lazy() {
    const { AdminPinSetup } = await import("./AdminPinSetup");
    return { Component: AdminPinSetup };
  },
};

export const selectProfileRoutes = {
  path: urls.select_profile,
  async lazy() {
    const { SelectProfile } = await import("./SelectProfile");
    return { Component: SelectProfile };
  },
};
